import { BaseRequest } from 'planning-portal-library/src/lib/data/shared/base.request';
import { Observable } from "rxjs";
import { DistributionLane } from "../domain";

export abstract class DistributionLaneRepository {
    
    abstract getDistributionLanes(request: BaseRequest<any>): Observable<DistributionLane[]>;
}